import React from 'react';
import { ButtonBase, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppLanguage } from '../../i18n/locale-resources';

interface LanguageToggleProps {
  size?: number;
}

// Two-language switch: shows the code of the language a click switches to.
export const LanguageToggle = ({ size = 30 }: LanguageToggleProps) => {
  const { t, i18n } = useTranslation();
  const next: AppLanguage = i18n.language === 'vi' ? 'en' : 'vi';

  return (
    <Tooltip title={t('language.' + next)}>
      <ButtonBase
        onClick={() => i18n.changeLanguage(next)}
        aria-label={t('language.switchTo')}
        sx={{
          width: size,
          height: size,
          flex: 'none',
          border: '1px solid var(--border)',
          borderRadius: size >= 36 ? '9px' : '7px',
          backgroundColor: 'var(--card)',
          color: 'var(--fg)',
          fontSize: size >= 36 ? 12 : 11,
          fontWeight: 600,
          letterSpacing: '.02em',
        }}
      >
        {next.toUpperCase()}
      </ButtonBase>
    </Tooltip>
  );
};
